import { inject } from 'inversify';
import { Injectable } from '../../decorators/injectable';
import { HttpService, type IHttpService } from '../http/http.service';
import type {
  CreateSignupLinkPayload,
  ISignupLinkService,
  SignupLinkItem,
  SignupLinkListFilter,
  SignupLinkListResult,
} from './signup-link.service.interface';

@Injectable()
export class SignupLinkService implements ISignupLinkService {
  constructor(@inject(HttpService) private readonly http: IHttpService) {}

  async list(filter?: SignupLinkListFilter): Promise<SignupLinkListResult> {
    const query = new URLSearchParams();
    if (filter?.consultantUserId) {
      query.set('consultantUserId', filter.consultantUserId);
    }
    if (filter?.page !== undefined) {
      query.set('page', String(filter.page));
    }
    if (filter?.pageSize !== undefined) {
      query.set('pageSize', String(filter.pageSize));
    }
    const queryString = query.toString();
    return this.http.get<SignupLinkListResult>(
      queryString ? `admin/signup-links?${queryString}` : 'admin/signup-links',
    );
  }

  async create(payload: CreateSignupLinkPayload): Promise<SignupLinkItem> {
    return this.http.post<SignupLinkItem>('admin/signup-links', payload);
  }

  async revoke(id: string): Promise<void> {
    await this.http.post<void>(`admin/signup-links/${id}/revoke`, {});
  }

  async claim(token: string): Promise<boolean> {
    const { claimed } = await this.http.post<{ claimed: boolean }>('signup-link/claim', { token });
    return claimed;
  }
}
